import React, { useEffect, useState } from "react";
import { BaseBudgetInput } from "../../components/budget/BaseBudgetInput";
import { _ROLES_BACK, _ACTIVITIES } from "../../utils/constants";
import { AgGridQuarryingExcavator } from "../../components/budget/quarrying-excavator/AgGridQuarryingExcavator";
import { _ROUTES } from "../../utils/_routes_constants";
import {
  LINKED_QUARRYING_EXCAVATOR_DATA,
  SAVE_CATEGORY_QUARRYING_EXCAVATOR,
} from "../../utils/savedDataConstant/quarryingExcavatorSaveConstants";
import { sendToFinancialData } from "../../components/budget/BaseBudgetSaveFunctions";

export const InputQuarryingExcavator = () => {
  const [saveData, setSaveData] = useState([]);
  const arrayData = LINKED_QUARRYING_EXCAVATOR_DATA;
  const save_name_category = SAVE_CATEGORY_QUARRYING_EXCAVATOR;
  const [params, setParams] = useState({});

  useEffect(() => {
    if (saveData.length > 0) {
      const modifiedData = saveData
        ?.map((d) => {
          if (!d) return null;

          const payload = {
            activityName: "LRU",
            siteId: params.site,
            theme: d.theme,
            months: {},
          };

          for (let i = 1; i <= 12; i++) {
            payload.months[i] = d[i] || 0;
          }

          return payload;
        })
        .filter((item) => item !== null);

      sendToFinancialData(modifiedData, save_name_category, () => {
        setSaveData([]);
      });
    }
  }, [saveData]);

  const handleOnSaveDataBefore = (gridRef, rowData) => {
    const aggregationRows = [];

    // Get all rendered nodes (visible rows)
    const renderedNodes = gridRef.current.api.getRenderedNodes();

    // Filter for group total rows
    renderedNodes.forEach((node) => {
      if (node.group && node.footer) {
        const aggregationRow = {
          theme: node.key,
        };

        for (let i = 1; i <= 12; i++) {
          aggregationRow[i] = node.aggData[i] || 0;
        }

        aggregationRows.push(aggregationRow);
      }
    });

    return aggregationRows;
  };

  return (
    <BaseBudgetInput
      title="Input Quarrying Excavator"
      roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL]}
      userRole={_ROLES_BACK._ROLE_LRU}
      enableFlag="dataEntryEnableLru"
      TableComponent={AgGridQuarryingExcavator}
      saveData={saveData}
      setSaveData={setSaveData}
      includeBaseBudgetSave={true}
      arrayData={arrayData}
      saveNameCategory={save_name_category}
      onParamsChange={setParams}
      onSaveDataBefore={handleOnSaveDataBefore}
      filters={[
        {
          key: "site",
          route: _ROUTES.SITES,
          defaultValue: "",
          label: "Site",
          queryParams: {
            active: 1,
            "activity.code": _ACTIVITIES.LRU,
            "exists[sources]": 1,
            "order[name]": "ASC",
            "groups[]": "select:get",
          },
        },
      ]}
    />
  );
};
